import React from "react";
import { Form, Input } from "antd";

const PaymentDescription = (props) => {
  // -------------------------- VAR --------------------------
  const { disabled } = props;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="description"
      label="Shop Name"
      rules={[
        {
          required: true,
          message: "Please input Shop Name",
        },
        {
          whitespace: true,
          message: "Please input Shop Name",
        },
      ]}
    >
      <Input
        showCount
        maxLength={32}
        placeholder="Shop Name"
        disabled={disabled}
      />
    </Form.Item>
  );
};

export default PaymentDescription;
